// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

// --- HS Code
import { NavBarBaseComponent } from '../../../core/nav-bar/nav-bar-base.component';

// #endregion

@Component({
  selector: 'hs-dashboard-top-nav-mobile',
  templateUrl: './dashboard-top-nav-mobile.component.html',
  styleUrls: ['./dashboard-top-nav-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTopNavMobileComponent extends NavBarBaseComponent {
  @Input() hasNotifications: boolean | null = false;
  @Input() isOpen: boolean | null = false;
  @Input() numberOfNewNotifications: number | null = 0;

  @Output() notifications = new EventEmitter();
  @Output() toggleNavigation = new EventEmitter();

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }

  toggleNavigationClick() {
    if (this.isLoading) {
      return;
    }

    this.toggleNavigation.emit(!this.isOpen);
  }

  notificationsClick() {
    if (this.isLoading) {
      return;
    }

    this.notifications.emit();
  }
}
